import { define } from '../../define.js';
import { Divider } from './divider.js';
export * from './divider.js';
define('divider', Divider);
